import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import AdminLayout from '../components/admin/AdminLayout';

// Admin pages
const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const AdminArtists = lazy(() => import('../pages/admin/AdminArtists'));
const SuperAdmin = lazy(() => import('../pages/admin/SuperAdmin'));
const AdminStreamers = lazy(() => import('../pages/admin/AdminStreamers'));
const AdminScheduledJobs = lazy(() => import('../pages/admin/AdminScheduledJobs'));
const AdminAffiliateManagement = lazy(() => import('../pages/admin/AdminAffiliateManagement'));
const AdminPayoutManagement = lazy(() => import('../pages/admin/AdminPayoutManagement'));
const AdminConversions = lazy(() => import('../pages/admin/AdminConversions'));
const AdminAnalytics = lazy(() => import('../pages/admin/AdminAnalytics'));
const AdminEmailTemplates = lazy(() => import('../pages/admin/AdminEmailTemplates'));
const AdminEmailTemplateDetail = lazy(() => import('../pages/admin/AdminEmailTemplateDetail'));

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#02172a',
    color: '#fff'
  }}>
    <div>Loading admin interface...</div>
  </div>
);

const AdminRouter: React.FC = () => {
  return (
    <AdminLayout>
      <Suspense fallback={<LoadingSpinner />}>
        <Switch>
          {/* Admin Dashboard */}
          <Route exact path="/dashboard" component={AdminDashboard} />
          <Route exact path="/admin/dashboard" render={() => <Redirect to="/dashboard" />} />
          
          {/* SuperAdmin - Artist Management */}
          <Route exact path="/admin/superadmin" component={SuperAdmin} />
          <Route exact path="/superadmin" component={SuperAdmin} />

          {/* Production-order aliases */}
          <Route exact path="/admin/artists" component={AdminArtists} />
          <Route exact path="/admin/streamers" component={AdminStreamers} />
          <Route exact path="/admin/earnings" component={AdminAnalytics} />
          <Route exact path="/admin/scheduled-jobs" component={AdminScheduledJobs} />
          <Route exact path="/admin/approvals" render={() => <Redirect to="/admin/affiliates?status=pending" />} />
          <Route exact path="/admin/affiliate" component={AdminAffiliateManagement} />
          <Route exact path="/admin/communications" component={AdminEmailTemplates} />

          <Route exact path="/admin/affiliates" component={AdminAffiliateManagement} />
          <Route exact path="/admin/payouts" component={AdminPayoutManagement} />
          <Route exact path="/admin/conversions" component={AdminConversions} />

          {/* Analytics */}
          <Route exact path="/admin/analytics" component={AdminAnalytics} />
          <Route exact path="/analytics" component={AdminAnalytics} />

          {/* Email management */}
          <Route exact path="/admin/emails" component={AdminEmailTemplates} />
          <Route exact path="/admin/emails/:id" component={AdminEmailTemplateDetail} />
          <Route exact path="/emails" component={AdminEmailTemplates} />
          <Route exact path="/emails/:id" component={AdminEmailTemplateDetail} />
          
          {/* Default admin route */}
          <Route exact path="/admin" render={() => <Redirect to="/dashboard" />} />
          
          {/* Fallback redirect */}
          <Redirect to="/dashboard" />
        </Switch>
      </Suspense>
    </AdminLayout>
  );
};

export default AdminRouter;
